import React from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { faqs } from '../data/mock';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../components/ui/accordion';
import { HelpCircle, MessageSquare } from 'lucide-react';
import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';

export default function FAQPage() {
  return (
    <div className="min-h-screen">
      <SEO
        title="Frequently Asked Questions"
        path="/faq"
        description="Frequently asked questions about Naviton Global's import and export services, shipping, compliance, and trade processes."
      />
      <Header />
      <main>
        {/* Hero Section */}
        <section className="pt-32 pb-20 bg-navy-900">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <span className="inline-block px-4 py-1.5 rounded-full bg-teal-500/20 text-teal-400 text-sm font-medium mb-6">
                Support
              </span>
              <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
                Frequently Asked
                <span className="block text-teal-400">Questions</span>
              </h1>
              <p className="text-xl text-slate-300 max-w-3xl mx-auto">
                Find answers to common questions about our import and export services, 
                processes, and how we can help your business.
              </p>
            </div>
          </div>
        </section>

        {/* FAQ Section */}
        <section className="py-20 bg-white">
          <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
            <Accordion type="single" collapsible className="space-y-4">
              {faqs.map((faq, index) => (
                <AccordionItem
                  key={index}
                  value={`item-${index}`}
                  className="bg-slate-50 rounded-2xl border border-slate-200 px-6 overflow-hidden data-[state=open]:border-teal-300 data-[state=open]:shadow-lg transition-all duration-200"
                >
                  <AccordionTrigger className="text-left text-lg font-semibold text-navy-900 hover:no-underline py-6">
                    <div className="flex items-start gap-4">
                      <div className="p-2 rounded-lg bg-navy-900 flex-shrink-0">
                        <HelpCircle className="h-5 w-5 text-white" />
                      </div>
                      <span>{faq.question}</span>
                    </div>
                  </AccordionTrigger>
                  <AccordionContent className="text-slate-600 leading-relaxed pl-14 pb-6">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        </section>

        {/* Still Have Questions */}
        <section className="py-20 bg-slate-50">
          <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
            <MessageSquare className="h-16 w-16 text-teal-600 mx-auto mb-6" />
            <h2 className="text-3xl font-bold text-navy-900 mb-4">
              Still Have Questions?
            </h2>
            <p className="text-lg text-slate-600 mb-8">
              Can't find the answer you're looking for? Our team is here to help.
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center px-8 py-4 bg-navy-900 hover:bg-navy-800 text-white font-medium rounded-xl transition-colors"
            >
              Contact Our Team
            </Link>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
